<template>
  <div class="base-wrapper order-wrapper">
    <h2 class="second-page-title center bold">
      {{ title }}
    </h2>
    <img
      class="half-drawer-close"
      src="../../assets/close.png"
      @click="backIndex"
    />

    <div class="iframe-wrapper">
      <iframe
        ref="iframe"
        :src="link"
        frameborder="0"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { VisiblePage } from '@/common';

export default Vue.extend({
  name: 'OrderItem',

  props: {
    link: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },

  methods: {
    backIndex() {
      this.$emit('toggleVisiblePage', VisiblePage.index);
    },
  },
});
</script>

<style lang="less" scoped>
@import '../../styles/variable.less';

.order-wrapper {
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;

  .iframe-wrapper {
    flex: 1;
    position: relative;
    background: #fff;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;

    iframe {
      position: absolute; // 适配兼容，华为 NXT-TL00
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
